import { useQuery } from "react-query";
import { getVoidedInvoices } from "../../../../../actions/CarrierAgreementMgmt/VendorInvoice";

export const useGetVoidedInvoices = () => {
  return useQuery("GetVoidedInvoices", getVoidedInvoices, {
    refetchOnWindowFocus: false,
  });
};
